export const getHasNowoNumber = (state) => {
  if (!state.portability) return true;

  return state.addicionalNumbers.some(number => !number.portability);
};
export const getPortability = state => state.portability;
export const getAddicionalNumbers = state => state.addicionalNumbers;
export const getAvailableNumbers = state => state.availableNumbers;
export const getChosenNumber = state => state.chosenNumber;
export const getPaymentEntity = state => state.paymentInfo.entity;
export const getPaymentRef = state => state.paymentInfo.ref;
export const getPaymentTotal = state => state.paymentInfo.total;
export const getLastSessionId = state => state.lastSessionId;
export const getPortabilityInfo = state => state.portabilityInfo;
export const getPortabilityInfoProvider = state => state.portabilityInfo.provider;

export default {
  getHasNowoNumber,
  getPortability,
  getAddicionalNumbers,
  getAvailableNumbers,
  getChosenNumber,
  getPaymentEntity,
  getPaymentRef,
  getPaymentTotal,
  getLastSessionId,
  getPortabilityInfo,
  getPortabilityInfoProvider
};



// WEBPACK FOOTER //
// ./src/store/modules/movel/getters.js